import styled from 'styled-components'

export const ContainerGlobal = styled.div`
  flex-direction: column;
`

export function isResponsiveFunction(): boolean {
  return typeof window !== 'undefined' && window.matchMedia('(max-width: 1360px)').matches
}
